import React, { FunctionComponent } from "react";
import { Container, createStyles, Link, makeStyles } from "@material-ui/core";
import Typography from "../../shared/components/Typography";
import Page from "../../shared/components/Page";
import SiteFooter from "../../shared/views/SiteFooter";
import { Link as RouterLink } from "react-router-dom";
import ScrollToTopOnMount from "../../shared/components/ScrollToTopOnMount";
import { h5 } from "../../shared/styles";
import { AppLinkHrefs } from "../../navigation/navigationHelpers";

const useStyles = makeStyles((theme) =>
  createStyles({
    ...h5(theme),
    root: {
      backgroundColor: theme.palette.background.default,
      minHeight: "100%",
      paddingTop: theme.spacing(15),
      paddingBottom: theme.spacing(3),
    },
    container: {
      marginBottom: theme.spacing(15),
      alignItems: "center",
      position: "relative",
      display: "flex",
      flexDirection: "column",
    },
    textWithMargin: {
      marginTop: theme.spacing(11),
    },
  })
);

const Gumroad: FunctionComponent = (props) => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Thanks for ordering!">
      <ScrollToTopOnMount />
      <Container className={classes.container} maxWidth="md">
        <Typography variant="h3" gutterBottom marked="center" align="center">
          Thanks!
        </Typography>
        <Typography variant="h5" className={classes.h5} align="center">
          Thanks for pre-ordering the Web Field Guide! I'm currently working on
          the next few chapters and getting ready for the launch in mid
          September. The initial launch will have everything you need to get
          your web app off the ground and running, and I'll be quickly adding
          new content from there until I've shown you everything I did to build
          this site. In the meantime I've already written the first two
          chapters. I'd encourage you to{" "}
          <Link
            component={RouterLink}
            to={AppLinkHrefs.Introduction}
            key="intro"
            underline="always"
          >
            check them out
          </Link>{" "}
          and get started building!
        </Typography>
      </Container>
      <SiteFooter />
    </Page>
  );
};

export default Gumroad;
